/* B2B observations and native contact-form success. No customer text enters analytics. */
(function () {
  'use strict';
  if (window.__jjB2BEvents) return;
  window.__jjB2BEvents = true;
  var pendingKey = 'jj.b2b.pending.v1';
  var sentPrefix = 'jj.b2b.sent.';
  var ga4SentPrefix = 'jj.b2b.ga4.sent.';
  var destination = 'AW-18453056997/RooxCIWH4vgcEOWbjd9E';
  var adsConfigured = false;
  var adsWait = null;
  var ga4 = 'G-WK0YT6J69Q';
  var ga4Configured = false;
  var ga4Wait = null;
  var path = window.location.pathname;
  var page = path.replace(/^\/(de|fr|it|es)(?=\/)/, '');
  var test = new URLSearchParams(window.location.search).get('jj_test') === '1';
  var form = document.querySelector('.jj-quote__form');
  function requestIntent(pending) {
    var field = form && form.querySelector('[name="contact[Request type]"]');
    var value = field && field.value;
    if (field && !['business', 'dealer', 'custom', 'Bulk pre-order (out of stock, min 10, no payment yet)'].includes(value)) return '';
    // A native POST may drop an alternate-template view; measure the matching submitted request.
    if (pending && Object.prototype.hasOwnProperty.call(pending, 'intent')) value = pending.intent;
    if (['business', 'dealer', 'custom'].includes(value)) return value;
    // Exact existing MAIN preorder marker remains the original purchase enquiry goal.
    if (value === 'Bulk pre-order (out of stock, min 10, no payment yet)') return 'business';
    // Compatibility only for legacy forms/records that predate this field; an explicit unknown type is not a quote.
    return field || (pending && Object.prototype.hasOwnProperty.call(pending, 'intent')) ? '' : 'business';
  }

  function get(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }
  function put(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (e) { return false; }
  }
  function consent(kind) {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      return !!cp && cp.currentVisitorConsent()[kind] === 'yes' &&
        (kind === 'marketing' ? cp.marketingAllowed() : cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  // Only approved campaign codes enter the existing success event or notification.
  var sourceKey = 'jj.b2b.source.v1';
  var sourceMap = {"letter_next":["letterxpress","direct_mail","de_campsites_202609","lx50_next"],"mail_b01":["lancy","outreach_email","b2b_202609","b01"],"creator_c01":["creator","editorial","creator_202609","c01"],"link_op01":["k0tfu","referral","resources_202609","op01"],"link_op02":["dxzone","referral","resources_202609","op02"],"link_op03":["besthamradio","referral","resources_202609","op03"]};
  function sourceContext() {
    if (!consent('analytics') || !consent('marketing')) {
      var choice;
      try { choice = Shopify.customerPrivacy.currentVisitorConsent(); } catch (e) {}
      // A not-yet-loaded consent API is not an explicit withdrawal.
      if (choice && (choice.analytics === 'no' || choice.marketing === 'no')) {
        try { sessionStorage.removeItem(sourceKey); } catch (e) {}
        var pending = get(pendingKey);
        if (pending && pending.source) { pending.source = ''; put(pendingKey, pending); }
      }
      return '';
    }
    var q = new URLSearchParams(location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
    if (['gclid', 'gbraid', 'wbraid'].some(function (key) { return q.has(key); })) {
      try { sessionStorage.removeItem(sourceKey); } catch (e) {}
      return '';
    }
    var code = Object.keys(sourceMap).find(function (key) {
      return keys.every(function (name, i) { return q.get(name) === sourceMap[key][i]; });
    });
    if (code) {
      put(sourceKey, {code: code, at: Date.now()});
      return code;
    }
    // An unrecognised new campaign must not inherit an older campaign.
    if (keys.some(function (key) { return q.has(key); })) {
      try { sessionStorage.removeItem(sourceKey); } catch (e) {}
      return '';
    }
    var saved = get(sourceKey);
    if (!saved || !Object.prototype.hasOwnProperty.call(sourceMap, saved.code) ||
        typeof saved.at !== 'number' || Date.now() - saved.at < 0 ||
        Date.now() - saved.at > 30 * 60 * 1000) return '';
    return saved.code;
  }
  function sourceFields() {
    var code = sourceContext();
    if (form) {
      var input = form.querySelector('[data-jj-source-code]');
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden';
        input.name = 'contact[Source code]'; input.setAttribute('data-jj-source-code', '');
        form.insertBefore(input, form.firstChild);
      }
      input.value = code;
    }
    return code;
  }
  function setupField() {
    if (!form) return;
    // Explicit kit selection is enquiry context, never an analytics dimension.
    var value = new URLSearchParams(location.search).get('setup') || '';
    if (value.length > 128 || !/^(?:us-)?business-(?:hospitality|events-security|warehouse-logistics|education-clubs):r[1-9][0-9]{5,19}x[1-9][0-9]{0,3}(?::a[1-9][0-9]{5,19}x[1-9][0-9]{0,3})?$/.test(value)) value = '';
    var input = form.querySelector('[data-jj-original-setup]');
    if (!input && !value) return;
    if (!input) {
      input = document.createElement('input'); input.type = 'hidden';
      input.name = 'contact[Original setup]'; input.setAttribute('data-jj-original-setup', '');
      form.insertBefore(input, form.firstChild);
    }
    input.value = value;
  }

  function id() {
    if (!window.crypto || !crypto.getRandomValues) return '';
    var bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return Array.prototype.map.call(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
  }
  // Any success page whose stored submission is TEST stays out of GA4, whatever its path or age
  // (same scope as the Ads gate); a real submission always overwrites it with test: false.
  function testSuccess() {
    var pending = get(pendingKey);
    return !!(document.querySelector('[data-jj-quote-success]') && pending && pending.test);
  }
  function ga4TagReady() {
    return !!(window.google_tag_manager && window.google_tag_manager['GT-MJPGZQVL']);
  }
  // Page-view gate only: Shopify's effective analytics permission, so regions without a consent
  // requirement count an unchosen visitor. An explicit "no", GPC without an explicit "yes", or any
  // API failure still blocks. UTM/src campaign codes follow this gate (coordinator T1014-01); micro-events,
  // conversions, click IDs and form source codes keep consent().
  // 'yes' sends, 'no' stops waiting, 'unknown' (API missing or throwing) keeps waiting without sending.
  function pageViewPermission() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (!cp) return 'unknown';
      var choice = cp.currentVisitorConsent().analytics;
      if (choice === 'no') return 'no';
      if (choice !== 'yes' && navigator.globalPrivacyControl === true) return 'no';
      return cp.analyticsProcessingAllowed() === true ? 'yes' : 'no';
    } catch (e) { return 'unknown'; }
  }
  // At most one GA4 page_view per page, outside TEST, only when pageViewPermission() is 'yes'.
  function configureGa4() {
    if (test || testSuccess() || pageViewPermission() !== 'yes' || typeof window.gtag !== 'function' || !ga4TagReady()) return false;
    if (!ga4Configured) {
      ga4Configured = true;
      var landing = new URL(location.origin + path);
      var campaignParams = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'src'].forEach(function (key) {
        var value = campaignParams.get(key);
        if (value && /^[A-Za-z0-9._~%+\-|]{1,200}$/.test(value)) landing.searchParams.set(key, value);
      });
      var referrer = '';
      try {
        var source = new URL(document.referrer);
        var currentHostname = location.hostname || new URL(location.origin).hostname;
        if ((source.protocol === 'https:' || source.protocol === 'http:') &&
            source.hostname.replace(/^www\./, '') !== currentHostname.replace(/^www\./, '')) referrer = source.origin;
      } catch (e) {}
      // Ad click identifiers are attribution data, so they also need marketing consent.
      if (consent('analytics') && consent('marketing')) {
        var params = new URLSearchParams(location.search);
        ['gclid', 'gbraid', 'wbraid'].forEach(function (key) {
          var value = params.get(key);
          if (value && /^[A-Za-z0-9_-]{1,512}$/.test(value)) landing.searchParams.set(key, value);
        });
      }
      // G- is a destination inside the Shopify channel's Google tag, which ignores duplicate config
      // commands, so this config may be dropped; the single page_view is therefore an explicit event.
      // Fixed title: Shopify search page titles contain the visitor's query.
      window.gtag('config', ga4, {
        send_page_view: false, page_location: landing.href, page_referrer: referrer, page_title: 'JUCJET',
        allow_google_signals: false, allow_ad_personalization_signals: false
      });
      window.gtag('event', 'page_view', {
        send_to: ga4, page_location: landing.href, page_referrer: referrer, page_title: 'JUCJET'
      });
    }
    return true;
  }
  // Keep trying for two minutes while the consent API or the Google tag is still loading.
  function ga4Waiting() {
    return !test && !testSuccess() && pageViewPermission() !== 'no';
  }
  function startGa4() {
    if (ga4Wait || configureGa4() || !ga4Waiting()) return;
    var tries = 0;
    ga4Wait = setInterval(function () {
      tries += 1;
      if (configureGa4()) success();
      if (ga4Configured || !ga4Waiting() || tries >= 120) { clearInterval(ga4Wait); ga4Wait = null; }
    }, 1000);
  }
  function observe(name, details, key) {
    // Micro-events follow GA4's page_view and go to GA4 only, never to GT or Ads.
    if (!consent('analytics') || !configureGa4()) return false;
    if (key && get(key)) return false;
    if (key && !put(key, true)) return false;
    // The existing Google tag remains the sole loader. Explicit safe location omits all query data.
    window.gtag('event', name, Object.assign({
      send_to: ga4, page_location: location.origin + path,
      page_referrer: '', page_title: 'JUCJET', page_path: page
    }, details || {}));
    return true;
  }
  function adsConsentReady() {
    if (!window.dataLayer || !Array.isArray(window.dataLayer)) return false;
    var latest = {};
    var ambiguous = {};
    var updated = {};
    window.dataLayer.forEach(function (entry) {
      if (!entry || entry[0] !== 'consent' || !['default', 'update'].includes(entry[1]) || !entry[2]) return;
      var regional = Object.prototype.hasOwnProperty.call(entry[2], 'region');
      ['ad_storage', 'ad_user_data', 'ad_personalization'].forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(entry[2], key)) return;
        if (regional) {
          // Without a verified visitor region, a scoped value cannot grant globally.
          ambiguous[key] = true;
          delete latest[key];
          updated[key] = false;
        } else if (entry[1] === 'update') {
          latest[key] = entry[2][key];
          ambiguous[key] = false;
          updated[key] = true;
        } else if (!ambiguous[key] && !updated[key]) {
          // A later default cannot resolve regional ambiguity or override a choice.
          latest[key] = entry[2][key];
        }
      });
    });
    return !ambiguous.ad_storage && !ambiguous.ad_user_data && !ambiguous.ad_personalization &&
      latest.ad_storage === 'granted' && latest.ad_user_data === 'granted' &&
      latest.ad_personalization === 'granted';
  }
  function configureAds() {
    var pending = get(pendingKey);
    if (test || (document.querySelector('[data-jj-quote-success]') && pending && pending.test) ||
        !consent('marketing') || typeof window.gtag !== 'function' || !adsConsentReady()) return false;
    if (!adsConfigured) {
      var landing = new URL(location.origin + path);
      var params = new URLSearchParams(location.search);
      ['gclid', 'gbraid', 'wbraid'].forEach(function (key) {
        var value = params.get(key);
        if (value && /^[A-Za-z0-9_-]{1,512}$/.test(value)) landing.searchParams.set(key, value);
      });
      window.gtag('config', 'AW-18453056997', {
        send_page_view: false, allow_enhanced_conversions: false,
        allow_google_signals: false, page_location: landing.href, page_referrer: ''
      });
      adsConfigured = true;
    }
    return true;
  }
  function adsTagReady() {
    return !!(window.google_tag_manager && window.google_tag_manager['AW-18453056997']);
  }
  function success() {
    if (!document.querySelector('[data-jj-quote-success]')) return;
    var p = get(pendingKey);
    if (!p || p.path !== path || !/^[a-f0-9]{32}$/.test(p.id) ||
        Date.now() - p.at < 0 || Date.now() - p.at > 30 * 60 * 1000 || p.test || test || p.supportOnly) return;
    // The GA4 submission follows analytics consent; Ads has a separate marketing gate.
    var enquiryIntent = requestIntent(p);
    if (!enquiryIntent) return;
    var submitEvent = enquiryIntent === 'dealer' ? 'b2b_dealer_apply_submit' :
      (enquiryIntent === 'custom' ? 'b2b_custom_enquiry_submit' : 'b2b_quote_submit');
    observe(submitEvent, {
      request_id: p.id,
      source_code: Object.prototype.hasOwnProperty.call(sourceMap, p.source) ? p.source : 'unknown'
    }, ga4SentPrefix + p.id);
    // New enquiry types are measured separately; they do not change the existing purchase-intent Ads goal.
    if (enquiryIntent !== 'business') return;
    if (!consent('marketing') || typeof window.gtag !== 'function' || !adsConsentReady() || get(sentPrefix + p.id)) return;
    if (!configureAds()) return;
    // A gtag queue stub can accept calls even when the Ads runtime never loads.
    if (!adsTagReady()) return;
    // At-most-once in this tab; Ads transaction_id also deduplicates the same submission.
    if (!put(sentPrefix + p.id, true)) return;
    window.gtag('event', 'conversion', {
      send_to: destination, transaction_id: p.id,
      page_location: location.origin + path, page_referrer: '', page_title: 'JUCJET team enquiry'
    });
  }
  if (form) {
    var request = form.querySelector('[data-jj-request-id]');
    var testField = form.querySelector('[data-jj-test]');
    if (testField) testField.value = test ? 'yes' : 'no';
    form.addEventListener('submit', function () {
      if (!form.checkValidity() || !request) return;
      setupField();
      if (!request.value) request.value = id();
      var country = form.querySelector('[data-jj-country]');
      var useCountry = form.querySelector('[data-jj-use-country]');
      var supportOnly = (country && country.value === 'RU') || (useCountry && useCountry.value === 'RU');
      if (request.value) put(pendingKey, {id: request.value, at: Date.now(), path: path, test: test, supportOnly: !!supportOnly, source: sourceFields(), intent: requestIntent()});
    });
  }
  document.addEventListener('click', function (event) {
    var a = event.target.closest && event.target.closest('a[href]');
    if (!a) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (e) { return; }
    if (url.origin !== location.origin) return;
    var target = url.pathname.replace(/^\/(de|fr|it|es)(?=\/)/, '');
    if (target === '/pages/request-a-quote' || ((target === page || (page === '/pages/contact' && target === '/pages/business-orders')) && url.hash === '#jj-quote')) {
      observe('b2b_quote_cta_click', {target_path: target});
    }
    if (target === '/pages/volume-pricing') observe('b2b_pricing_click', {target_path: target});
    // No b2b_asset_download until an approved, public B2B asset actually exists.
  });
  var activeMs = 0, last = Date.now(), timer;
  if (/^\/pages\/(?:us-)?business-(hospitality|events-security|warehouse-logistics|education-clubs|campsites)$/.test(page)) {
    timer = setInterval(function () {
      var now = Date.now();
      if (document.visibilityState === 'visible' && document.hasFocus()) activeMs += Math.min(now - last, 1500);
      last = now;
      if (activeMs >= 60000 && observe('b2b_scene_engaged_60s', {}, 'jj.b2b.scene.' + page)) clearInterval(timer);
    }, 1000);
    window.addEventListener('pagehide', function () { clearInterval(timer); });
  }
  function activate() { sourceFields(); setupField(); configureAds(); success(); }
  function pendingConversion() {
    var p = get(pendingKey);
    if (requestIntent(p) !== 'business') return false;
    return !!(document.querySelector('[data-jj-quote-success]') && p && p.path === path && /^[a-f0-9]{32}$/.test(p.id) &&
      Date.now() - p.at >= 0 && Date.now() - p.at <= 30 * 60 * 1000 &&
      !p.test && !test && !p.supportOnly && !get(sentPrefix + p.id));
  }
  function adsWaiting() {
    var ready;
    try { ready = !!window.Shopify && typeof Shopify.customerPrivacy.currentVisitorConsent === 'function'; }
    catch (e) { ready = false; }
    return !test && !testSuccess() && (!ready || consent('marketing'));
  }
  function startAds() {
    if (adsWait || !adsWaiting() || (adsConfigured && !pendingConversion())) return;
    var tries = 0;
    adsWait = setInterval(function () {
      configureAds(); success();
      tries += 1;
      if ((adsConfigured && !pendingConversion()) || !adsWaiting() || tries >= 480) {
        clearInterval(adsWait); adsWait = null;
      }
    }, 250);
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (!consent('marketing')) { clearInterval(adsWait); adsWait = null; }
    // Let every Google tag consent listener finish before the Ads conversion is queued.
    setTimeout(function () { activate(); startAds(); }, 0);
  });
  if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
    Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
      if (!error) { activate(); startAds(); startGa4(); }
    });
  }
  activate();
  var readyAttempts = 0;
  var readyTimer = setInterval(function () {
    sourceFields(); setupField(); success();
    readyAttempts += 1;
    if (readyAttempts >= 10) clearInterval(readyTimer);
  }, 500);
  startAds();
  window.addEventListener('pagehide', function () {
    clearInterval(readyTimer);
    clearInterval(adsWait); adsWait = null;
  });
  // Shopify stores the new choice before dispatching. GA4 also runs one task later,
  // after the Google tag's consent-mode update listeners.
  document.addEventListener('visitorConsentCollected', function () { setTimeout(startGa4, 0); });
  startGa4();
  window.addEventListener('pagehide', function () { clearInterval(ga4Wait); ga4Wait = null; });
})();
